
import { useState, useEffect} from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


 

function InputText(props)
{

    
    
    
    const [val, setVal] = useState(props.value);
    const [kid, setKid] = useState(props.kid);
    const [req, setRequired] = useState(props.req);
    const [firstUp, setFirstUp] = useState(props.firstUp);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);


    
   

    const checkAndChange = (e) =>
    {
        var v = e.target.value;



        if(firstUp != undefined && firstUp == '1')
        {
            v =  v.charAt(0).toUpperCase() + v.slice(1);
        }


        setVal(v);

        var correct = true;

        if(req == '1' && v.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(kid,props.name, v);
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);

            
                    //---                            
                    var correct = true;                    
                    if(req == '1' && props.value.length < 1) correct = false;          
                        
               

                    if(correct == false)
                    {
                        setClassName('incorrent');
                    }else
                    {
                        setClassName('corrent');           
                    }              
                    //---

        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);

     
             props.valChange(kid,props.name, val);
            
    
        }
    })



    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }


    var cnX = cn;
    if( val !=null && val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }
   

    return <fieldset>
           <input type="text"   value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} />        
             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>             
           </fieldset>
}


export default InputText;